import {
  type ExternalToast,
  toast as sonnerToast,
} from '@unreserved/ui/components/sonner';
import { TIMEOUTS } from '@unreserved/constants';

interface ToastOptions extends ExternalToast {
  title?: string;
  description?: string;
}

export const useToast = () => {
  const duration = TIMEOUTS.TOAST;
  const toast = {
    success: (message: string, options?: ToastOptions) => {
      return sonnerToast.success(message, {
        ...options,
        description: options?.description,
        duration: options?.duration || duration,
      });
    },
    error: (message: string, options?: ToastOptions) => {
      return sonnerToast.error(message, {
        ...options,
        description: options?.description,
        duration: options?.duration || duration,
      });
    },
    info: (message: string, options?: ToastOptions) => {
      return sonnerToast.info(message, {
        ...options,
        description: options?.description,
        duration: options?.duration || duration,
      });
    },
    warning: (message: string, options?: ToastOptions) => {
      return sonnerToast.warning(message, {
        ...options,
        description: options?.description,
        duration: options?.duration || duration,
      });
    },
    default: (message: string, options?: ToastOptions) => {
      return sonnerToast(message, {
        ...options,
        description: options?.description,
        duration: options?.duration || duration,
      });
    },
    promise: <T>(
      promise: Promise<T> | (() => Promise<T>),
      options: {
        loading: string;
        success: string | ((data: T) => string);
        error: string | ((error: Error) => string);
      },
    ) => {
      return sonnerToast.promise(promise, options);
    },
  };

  return { toast };
};
